import Box from '@mui/material/Box/Box'
import Button from '@mui/material/Button/Button'
import Paper from '@mui/material/Paper/Paper'
import Typography from '@mui/material/Typography/Typography'
import { useMemo } from 'react'

import { useLocationContext } from '@providers/location/location_provider'
import { i18WithDefault as t, i18WithParams as tp } from '@shared/locale'
import { ContactToBookIcon } from 'components-ui/src/asset/contact_to_book_icon'
import { generatePhoneFromString } from 'components-ui/src/shared/common'

/**
 * The "Contact Us To Book" panel (icon, copy, phone button). Extracted from the
 * route page so it can be reused as an inline empty state, e.g. inside a room
 * tab where every offer is hidden/unavailable. Carries no routing or document
 * title side effects; the route page (ContactToBook) owns those.
 */
export const ContactToBookContent = () => {
  const { location } = useLocationContext()

  const phoneData = useMemo(() => location?.communications?.find((c) => c.type === 'PHONE'), [location])
  const phoneNumber = generatePhoneFromString(phoneData?.value)

  return (
    <Box sx={{ maxWidth: 700, margin: '0 auto', px: { xs: 2, sm: 3 }, py: 3 }}>
      <Paper elevation={0} sx={{ p: { xs: 3, sm: 4 }, borderRadius: 1, textAlign: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
          <ContactToBookIcon color="action" sx={{ fontSize: '3.5rem' }} />
        </Box>

        <Typography variant="h1">{t('contactToBook.title')}</Typography>

        <Typography variant="body1" sx={{ mt: 2 }}>
          {t('contactToBook.subtitle1')}
        </Typography>
        <Typography variant="body1">{t('contactToBook.subtitle2')}</Typography>

        {phoneData?.value && (
          <Button
            variant="contained"
            size="large"
            sx={{ pointerEvents: 'none', mt: 4, borderRadius: '4px', width: { xs: '100%', sm: 'auto' } }}
          >
            {tp('contactToBook.call', { phoneNumber })}
          </Button>
        )}
      </Paper>
    </Box>
  )
}
